///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { GtthEventManager } from '../../services/event-manager.service';
import { Principal } from '../auth/principal.service';
import { Router } from '@angular/router';
import { PreloaderService } from '../../services/preloader.service';
import { finalize } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { SuiTranslatePipe } from '@siklu/sui-lib/localization';
import { ButtonsDirectivesModule } from '../directives/buttons-directives/buttons-directives.module';

@Component({
    selector: 'winde-login-modal',
    templateUrl: './login.component.html',
    imports: [FormsModule, ButtonsDirectivesModule, SuiTranslatePipe]
})
export class LoginModalComponent implements AfterViewInit {
    public loginInProgress = false;
    public password: string;
    public username: string;

    constructor(
        private readonly eventManager: GtthEventManager,
        private readonly elementRef: ElementRef,
        private readonly principal: Principal,
        private readonly router: Router,
        private readonly preloaderService: PreloaderService
    ) {}

    ngAfterViewInit() {
        this.elementRef.nativeElement.querySelector('#username').focus();
    }

    login() {
        this.loginInProgress = true;
        this.preloaderService.show();

        this.principal
            .login(this.username, this.password)
            .pipe(
                finalize(() => {
                    this.preloaderService.hide();
                    this.loginInProgress = false;
                })
            )
            .subscribe({
                next: () => {
                    this.eventManager.broadcast({ name: 'gtthApp.httpError', content: false });
                    this.principal.identity(true).then(() => {
                        if (this.router.url.includes('reset')) {
                            this.router.navigate(['/']);
                        }
                    });
                },
                error: (error) => {
                    if (error.status === 401) {
                        error.error = {
                            message: 'login.messages.error.authentication'
                        };
                        this.eventManager.broadcast({ name: 'gtthApp.httpError', content: error });
                    }
                }
            });
    }

    resetPassword() {
        if (!this.loginInProgress) {
            this.router.navigate(['/reset/request']);
        }
    }
}
